import React, { ReactNode } from 'react';

import { Box, Tag, Text } from '@betterment/samba-react';
import { css } from '@betterment/samba-styled-system/css';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../../features/track';

type Props = {
  name: string;
  description: string;
  icon: ReactNode;
  to: string;
  analyticsKey: string;
  id?: string;
};

export const ProductOnboardingCrossSellItem: React.FC<Props> = ({ id, name, description, icon, to, analyticsKey }) => (
  <Box
    className={`group ${css({
      flex: 1,
      display: 'flex',
      backgroundColor: 'background.neutral',
    })}`}
  >
    <SambaAutoLink
      to={to}
      title={name}
      css={{
        flex: 1,
        padding: 'space.200',
        textDecoration: 'none!important',
      }}
      onClick={() => trackClick({ name: `explore_more_products_${analyticsKey}` })}
    >
      <Box css={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
        <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 'space.150' }}>
          {icon}
          {id === 'direct_trading' && <Tag accent="teal">New</Tag>}
        </Box>
        <Box css={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <Text css={{ color: 'text', _groupHover: { textDecoration: 'underline' } }}>{name}</Text>
          <Text css={{ textStyle: { base: 'text25', sm: 'text50' } }} color="text.weak">
            {description}
          </Text>
        </Box>
      </Box>
    </SambaAutoLink>
  </Box>
);
